import React, { useEffect, useState } from "react";
import { DropdownWrapper, SignupDropdownWrapper } from "../styles/ComponentStyles";
import apiService from "../services/apiService";

export const AmountTypeDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true); // To track loading state

  useEffect(() => {
    const fetchAmountTypes = async () => {
      try {
        const response = await apiService.getAmountTypeOptions();
        console.log('Amount Types Response:', response);  // Log the response
        setOptions(response || []);  // Ensure fallback to empty array
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching amount types:", error);
        setLoading(false);
      }
    };

    fetchAmountTypes();
  }, []);

  if (loading) return <div>Loading Amount Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="amount_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Amount Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

export const BillerTypeDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true); // To track loading state

  useEffect(() => {
    const fetchBillerTypes = async () => {
      try {
        const response = await apiService.getBillerTypeOptions();
        console.log('Biller Types Response:', response);  // Log the response
        setOptions(response || []);  // Ensure fallback to empty array
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching biller types:", error);
        setLoading(false);
      }
    };

    fetchBillerTypes();
  }, []);

  if (loading) return <div>Loading Biller Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="biller_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Biller Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

export const CashFlowTypeDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true); // To track loading state

  useEffect(() => {
    const fetchCashFlowTypes = async () => {
      try {
        const response = await apiService.getCashFlowTypeOptions();
        setOptions(response || []); // Ensure fallback to empty array if data is undefined
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching cash_flow types:", error);
        setLoading(false);
      }
    };

    fetchCashFlowTypes();
  }, []);

  if (loading) return <div>Loading CashFlow Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="cash_flow_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select CashFlow Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

export const SubscriptionDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscriptionTypes = async () => {
      try {
        const response = await apiService.getSubscriptionOptions();
        console.log('Subscription Types Response:', response);
        setOptions(response || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subscription types:", error);
        setLoading(false);
      }
    };

    fetchSubscriptionTypes();
  }, []);

  if (loading) return <div>Loading Subscription Types...</div>;

  return (
    <SignupDropdownWrapper>
      <select
        name="subscription"
        value={value || ""}
        onChange={onChange}
      >
        <option value="">Select Subscription Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </option>
          ))
        ) : (
          <option>No options available</option>
        )}
      </select>
    </SignupDropdownWrapper>
  );
};


export const ExpenseTypeDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true); // To track loading state

  useEffect(() => {
    const fetchExpenseTypes = async () => {
      try {
        const response = await apiService.getExpensesOptions();
        console.log('Expense Types Response:', response);
        setOptions(response.expense_types || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching expense types:", error);
        setLoading(false);
      }
    };

    fetchExpenseTypes();
  }, []);

  if (loading) return <div>Loading Expense Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="expense_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Expense Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

export const ExpensePlatformDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExpensePlatforms = async () => {
      try {
        const response = await apiService.getExpensesOptions();
        setOptions(response.platforms || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching expense platforms:", error);
        setLoading(false);
      }
    };

    fetchExpensePlatforms();
  }, []);

  if (loading) return <div>Loading Expense Platforms...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="platform"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Expense Platform</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

// BILLS
export const BillTypeDropdown = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true); // To track loading state

  useEffect(() => {
    const fetchBillTypes = async () => {
      try {
        const response = await apiService.getBillersOptions();
        setOptions(response.bill_types || []);  // Ensure fallback to empty array
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching bill types:", error);
        setLoading(false);
      }
    };

    fetchBillTypes();
  }, []);

  if (loading) return <div>Loading Bill Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="bill_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Bill Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

export const BillersDropdown = ({ value, onChange }) => {
  const [options, setBillers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBillOptions = async () => {
      try {
        const response = await apiService.getBillersOptions();
        // Parse the new format: values are objects like { "id": "name" }
        const parsedBillers = (response.billers || []).map(item => {
          const id = Object.keys(item)[0];
          const name = item[id];
          return { id, name };
        });
        setBillers(parsedBillers);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching bill options:", error);
        setLoading(false);
      }
    };

    fetchBillOptions();
  }, []);

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const selectedOption = options.find(opt => opt.id === selectedId);
    const selectedName = selectedOption ? selectedOption.name : '';

    // Call the parent's onChange. 
    // We can pass a simulated event or just the values.
    // Given the existing usage in Bills.js uses (e) => handleChange(e), 
    // it expects an event-like object or we need to change the parent.
    // Let's pass a custom object that mimics an event but carries both pieces of info if needed,
    // OR better, let's update the parent to accept (id, name) if we change the signature.
    // However, to keep it compatible with standard onChange pattern, 
    // we'll update the parent to use a specific handler for this dropdown.
    if (onChange) {
      onChange(selectedId, selectedName);
    }
  };

  if (loading) return <div>Loading Billers...</div>;

  return (
    <DropdownWrapper>
      <select
        name="biller" // Keep existing name for form data alignment if needed, but value is now ID
        value={value || ""}
        onChange={handleSelectChange}
        className="form-select"
      >
        <option value="">Select Biller</option>
        {options.length > 0 ? (
          options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))
        ) : (
          <option>No options available</option>
        )}
      </select>
    </DropdownWrapper>
  );
};

export const BillTypesDropdown = ({ value, onChange }) => {
  const [options, setBillTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBillOptions = async () => {
      try {
        const response = await apiService.getBillersOptions();
        setBillTypes(response.bill_types || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching bill options:", error);
        setLoading(false);
      }
    };

    fetchBillOptions();
  }, []);

  if (loading) return <div>Loading Bill Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="biller_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Bill Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};

export const BillPaymentTypesDropdown = ({ value, onChange }) => {
  const [options, setBillPaymentTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBillOptions = async () => {
      try {
        const response = await apiService.getBillersOptions();
        setBillPaymentTypes(response.bill_payment_types || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching bill options:", error);
        setLoading(false);
      }
    };

    fetchBillOptions();
  }, []);

  if (loading) return <div>Loading Bill Payment Types...</div>; // Loading state

  return (
    <DropdownWrapper>
      <select
        name="bill_payment_type"
        value={value || ""}
        onChange={onChange}
        className="form-select"
      >
        <option value="">Select Bill Payment Type</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize */}
            </option>
          ))
        ) : (
          <option>No options available</option> // Fallback message if no options
        )}
      </select>
    </DropdownWrapper>
  );
};